import AuthContext from "context/AuthContext";
import { isArray, startCase } from "lodash";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import helpers from "utils/helpers";

const RequirementListingView = ({ setViewShowModal, item }) => {
  const { t } = useTranslation();
  const { config } = useContext(AuthContext);

  const handleArray = (arr) => {
    if (isArray(arr) && arr.length > 0) {
      return arr.join(", ");
    }

    if (!isArray(arr) && arr) {
      return arr;
    }

    return "N/A";
  };

  const handlePrice = (price) => {
    if (price) {
      return `${price} ${config?.currency}`;
    }

    return "N/A";
  };

  const handleArea = (area) => {
    if (area) {
      return `${area} ${config?.areaUnit}`;
    }

    return "N/A";
  };

  return (
    <>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative w-auto my-6 mx-auto max-w-3xl">
          <form className="sm:py-4 sm:px-2 py-8 px-7">
            <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none min-w-[762px]">
              <div className="flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                <h3 className="text-xl font-semibold">{t("O_VIEW_USER")}</h3>
                <button
                  className=" ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none"
                  onClick={() => setViewShowModal(false)}
                >
                  <span className=" text-[#B8BBBF]  text-4xl " title="Close">
                    ×
                  </span>
                </button>
              </div>
              <div className="relative p-6 flex-auto">
                <div className=" border-2 rounded-md p-5">
                  <div className="grid grid-cols-2 ">
                    <div className="mb-3">
                      <div className="">
                        <strong>{t("O_FULL_NAME")}:</strong>
                      </div>
                      <div>
                        {startCase(
                          item?.name ||
                            `${item?.userDetail?.firstName || ""} ${
                              item?.userDetail?.lastName || ""
                            }`
                        ) || "N/A"}
                      </div>
                    </div>
                    {/* <div className='mb-3'>
                    <div className=''><strong>{t('O_MOBILE')}:</strong></div>
                    <div>{item?.mobile}</div>
                  </div> */}
                    <div className="mb-3">
                      <div className="">
                        <strong>{t("O_CITY")}:</strong>
                      </div>
                      <div>
                        {item?.cityDetail?.map((i) => i?.name).join(", ") ||
                          "N/A"}
                      </div>
                    </div>
                    <div className="mb-3">
                      <div className="">
                        <strong>{t("O_COMMUNITY")}:</strong>
                      </div>
                      <div>
                        {item?.neighbourhoodDetail
                          ?.map((i) => i?.name)
                          .join(", ") || "N/A"}
                      </div>
                    </div>
                    <div className="mb-3">
                      <div className="">
                        <strong>{t("O_SUB_COMMUNITY")}:</strong>
                      </div>
                      <div>
                        {item?.subcommunitiesDetail
                          ?.map((i) => i?.name)
                          .join(", ") || "N/A"}
                      </div>
                    </div>
                    <div className="mb-3">
                      <div className="">
                        <strong>{t("O_EMAIL_ID")}:</strong>
                      </div>
                      <div>
                        {item?.email || item?.userDetail?.email || "N/A"}
                      </div>
                    </div>
                    <div className="mb-3">
                      <div className="">
                        <strong>{t("O_MOBILE")}:</strong>
                      </div>
                      <div>{item?.mobile ? `+${item?.mobile}` : "N/A"}</div>
                    </div>
                    <div className="mb-3">
                      <div className="">
                        <strong>{t("PROPERTY_TYPE")}:</strong>
                      </div>
                      <div>
                        {handleArray(
                          isArray(item?.propertyType) &&
                            item?.propertyType?.length > 0 &&
                            item?.propertyType.map((i) => i?.name)
                        )}
                      </div>
                    </div>
                    <div className="mb-3">
                      <div className="">
                        <strong>{t("PROPERTY_AGE")}:</strong>
                      </div>
                      <div>{handleArray(item?.propertyAge)}</div>
                    </div>
                    <div className="mb-3">
                      <div className="">
                        <strong>{t("O_BUDGET_MIN")}:</strong>
                      </div>
                      <div>{handlePrice(item?.budgetMin)}</div>
                    </div>
                    <div className="mb-3">
                      <div className="">
                        <strong>{t("O_BUDGET_MAX")}:</strong>
                      </div>
                      <div>{handlePrice(item?.budgetMax)}</div>
                    </div>
                    <div className="mb-3">
                      <div className="">
                        <strong>{t("O_AREA_MIN")}:</strong>
                      </div>
                      <div>{handleArea(item?.areaMin)}</div>
                    </div>
                    <div className="mb-3">
                      <div className="">
                        <strong>{t("O_AREA_MAX")}:</strong>
                      </div>
                      <div>{handleArea(item?.areaMax)}</div>
                    </div>
                    <div className="mb-3">
                      <div className="">
                        <strong>{t("O_CATEGORY")}:</strong>
                      </div>
                      <div>{item?.categorySlug || "N/A"}</div>
                    </div>
                    <div className="mb-3">
                      <div className="">
                        <strong>{t("O_UNIT")}:</strong>
                      </div>
                      <div>{item?.unitTypeSlug || "N/A"}</div>
                    </div>
                    <div className="mb-3">
                      <div className="">
                        <strong>{t("O_STATUS")}:</strong>
                      </div>
                      <div>{item?.statusSlug || "N/A"}</div>
                    </div>
                    <div className="mb-3">
                      <div className="">
                        <strong>{t("O_FINANCE")}:</strong>
                      </div>
                      <div>{item?.financeTypeSlug || "N/A"}</div>
                    </div>
                    <div className="mb-3">
                      <div className="">
                        <strong>{t("O_BEDROOMS")}:</strong>
                      </div>
                      <div>{handleArray(item?.room)}</div>
                    </div>
                    <div className="mb-3">
                      <div className="">
                        <strong>{t("O_BATHROOMS")}:</strong>
                      </div>
                      <div>{handleArray(item?.bathRoom)}</div>
                    </div>
                    <div className="mb-3">
                      <div className="">
                        <strong>Property Status :</strong>
                      </div>
                      <div>{startCase(item?.propertyStatus) || "N/A"}</div>
                    </div>
                    <div className="mb-3">
                      <div className="">
                        <strong>Other Detail :</strong>
                      </div>
                      <div>{item?.otherDetail || "N/A"}</div>
                    </div>
                    <div className="mb-3">
                      <div>
                        <strong>{t("O_DESCRIPTION")}:</strong>
                      </div>
                      <div>{startCase(item?.description) || "N/A"}</div>
                    </div>
                    <div className="mb-3">
                      <div>
                        <strong>{t("O_CREATED_AT")}:</strong>
                      </div>
                      <div>{helpers.dateFormat(item?.createdAt) || "N/A"}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b">
                <button
                  className="text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150"
                  type="button"
                  onClick={() => setViewShowModal(false)}
                >
                  {t("O_CLOSE")}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black" />
    </>
  );
};

export default RequirementListingView;
